<template>
<div>
    <b-navbar toggleable="md" type="light" variant="light" class="px-2">
        <b-navbar-brand href="/"><strong>{{ env.APP_NAME }}</strong></b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
            <template v-if="auth_level > '000'">

                <b-navbar-nav>
                    <b-nav-item to="/forms"> フォーム </b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav class="ml-auto">
<!--
                    <b-nav-item @click="$router.push('/pages')">
                        Pages/Customers
                    </b-nav-item>
                    <b-nav-item @click="$router.push('/messages')">
                        Messages
                    </b-nav-item>
-->

                    <b-nav-item-dropdown
                        v-if="auth_level >= '300'"
                        text="設定"
                        class="mr-2"
                        right
                        >
                        <b-dropdown-item to="/users"> アカウント </b-dropdown-item>
                    </b-nav-item-dropdown>


                    <b-nav-item-dropdown right>
                        <!-- Using 'button-content' slot -->
                        <template v-slot:button-content>
                            <em>{{ auth_name }}</em>
                        </template>
                        <!--
                        <b-dropdown-item href="#">Profile</b-dropdown-item>
                        -->
                        <b-dropdown-item href="#" @click="logout">Logout</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </template>
            <template v-else>
            </template>
        </b-collapse>
    </b-navbar>
</div>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    computed: {
        ...mapGetters([
            'env',
            'auth_level',
            'auth_name',
        ])
    },
    methods: {
        logout () {
            location.href = '/auth/logout'
        },
    },
}
</script>
